/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Standings_Visibility_HintInputs */



/**
* | output |
* | --- |
* | "What players see during the preliminary rounds:" |
*
* @param {Og_Cfg_Standings_Visibility_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_standings_visibility_hint = /** @type {((inputs?: Og_Cfg_Standings_Visibility_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Standings_Visibility_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce que les joueurs voient pendant les rondes préliminaires :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lo que ven los jugadores durante las rondas preliminares:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O que os jogadores veem durante as rodadas preliminares:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cosa vedono i giocatori durante i round preliminari:")
	return /** @type {LocalizedString} */ ("What players see during the preliminary rounds:")
});